import { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { clearLoadingPhrase } from "loadingPhraseSlice";

import "./LoadingPhraseIndicator.css";

// Red de seguridad: si el turno muere sin que llegue la respuesta del
// bot (que es lo que limpia la frase), la frase se oculta sola tras
// este tiempo sin recibir frases nuevas.
const PHRASE_STALE_TIMEOUT_MS = 300000;

// Se renderiza vía typingIndicatorMiddleware (App.tsx). Mientras haya
// frase de "Cargando..." muestra los tres puntitos del typing MÁS la
// frase en gris; sin frase, cae al indicador default de Web Chat.
function LoadingPhraseIndicator(props: { defaultIndicator: any }) {
  const phrase = useSelector((state: any) => state.loadingPhrase.value);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!phrase) return;
    const staleTimer = setTimeout(() => {
      dispatch(clearLoadingPhrase());
    }, PHRASE_STALE_TIMEOUT_MS);
    return () => clearTimeout(staleTimer);
  }, [phrase, dispatch]);

  if (!phrase) {
    return <>{props.defaultIndicator}</>;
  }

  return (
    <div className="luca-loading-indicator">
      <span className="luca-loading-dots"></span>
      <span className="luca-loading-phrase" key={phrase}>
        {phrase}
      </span>
    </div>
  );
}

export default memo(LoadingPhraseIndicator);
